import { create } from 'zustand';

interface IItemGroupList {
  _id: string;
  groupName: string;
  items: number[];
  user?: {
    _id: string;
    empName: string;
    avatar: string;
  };
}

interface ItemState {
  OneItem: {
    id: number | null;
    isOpen: boolean;
  };
  ItemsOrderSheetIsOpen: boolean;
  CompanyItemsStatisticalDialogIsOpen: boolean;
  
  // Group viewing state
  viewingGroup: IItemGroupList | null;
  isViewingGroupOpen: boolean;
}

interface ItemActions {
  // Item dialog actions
  openItemDialog: (id: number) => void;
  closeItemDialog: () => void;

  // Items order sheet actions
  openItemsOrderSheet: () => void;
  closeItemsOrderSheet: () => void;

  // Company items statistical dialog actions
  openCompanyItemsStatisticalDialog: () => void;
  closeCompanyItemsStatisticalDialog: () => void;
  
  // Group viewing actions
  openGroupView: (group: IItemGroupList) => void;
  closeGroupView: () => void;

  // Utility actions
  closeAllItemDialogs: () => void;
}

export type ItemStore = ItemState & ItemActions;

export const useItemStore = create<ItemStore>((set) => ({
  // Initial state
  OneItem: {
    id: null,
    isOpen: false,
  },
  ItemsOrderSheetIsOpen: false,
  CompanyItemsStatisticalDialogIsOpen: false,
  viewingGroup: null,
  isViewingGroupOpen: false,

  // Item dialog actions
  openItemDialog: (id: number) =>
    set({
      OneItem: {
        id,
        isOpen: true,
      },
    }),

  closeItemDialog: () =>
    set({
      OneItem: {
        id: null,
        isOpen: false,
      },
    }),

  // Items order sheet actions
  openItemsOrderSheet: () =>
    set({
      ItemsOrderSheetIsOpen: true,
    }),

  closeItemsOrderSheet: () =>
    set({
      ItemsOrderSheetIsOpen: false,
    }),

  // Company items statistical dialog actions
  openCompanyItemsStatisticalDialog: () =>
    set({
      CompanyItemsStatisticalDialogIsOpen: true,
    }),

  closeCompanyItemsStatisticalDialog: () =>
    set({
      CompanyItemsStatisticalDialogIsOpen: false,
    }),
    
  // Group viewing actions
  openGroupView: (group: IItemGroupList) =>
    set({
      viewingGroup: group,
      isViewingGroupOpen: true,
    }),

  closeGroupView: () =>
    set({
      viewingGroup: null,
      isViewingGroupOpen: false,
    }),

  // Utility action
  closeAllItemDialogs: () =>
    set({
      OneItem: { id: null, isOpen: false },
      ItemsOrderSheetIsOpen: false,
      CompanyItemsStatisticalDialogIsOpen: false,
      viewingGroup: null,
      isViewingGroupOpen: false,
    }),
}));
